//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from 'swiper'
import makeDebug from 'debug'
import { EVENTS } from '@/scripts/constants/css-classes'

const debug = makeDebug('swiper')
export default {
  props: {
    config: Object,
    wrapperClass: String,
    navigation: Boolean, // mutual exclusion with dragIcon
    pagination: Boolean,
    thumbs: Object,
    dragIcon: Boolean, // mutual exclusion with navigation
    dataElementId: String,
    initialSlide: {
      type: Number,
      default: 0,
    },
    withNavigationArrow: {
      type: Boolean,
      default: true,
    },
    nextNavigation: {
      type: Object,
      default: () => undefined,
    },
    prevNavigation: {
      type: Object,
      default: () => undefined,
    },
    clickPrevButton: {
      type: Function,
      default: () => undefined,
    },
    clickNextButton: {
      type: Function,
      default: () => undefined,
    },
    slideToCenter: {
      type: [Boolean, Number],
      default: false,
    },
  },
  data: () => ({
    swiper: null,
    swiped: false,
  }),
  computed: {
    showPagination() {
      return this.pagination
    },
    showNavigation() {
      return this.navigation && this.slidesCount > 1
    },
    getSnapIndex() {
      return this.swiper.snapIndex
    },
    slides() {
      return this.$slots.default
    },
    slidesCount() {
      return this.slides.length ?? 0
    },
  },
  watch: {
    thumbs() {
      if (this.thumbs) {
        this._setup()
      }
    },
    slides(newValue) {
      this.$emit('slides', newValue)
    },
    nextNavigation() {
      this._setup()
    },
  },
  mounted() {
    if (this.thumbs === undefined) {
      this._setup()
    }
  },
  destroyed() {
    if (this.swiper) {
      this.swiper.destroy(true, false)
    }
  },
  methods: {
    async _setup() {
      const swiper = new Swiper(
        this.$refs.swiper,
        Object.assign(
          {},
          {
            initialSlide: this.initialSlide,
            navigation: {
              nextEl: this.nextNavigation ?? this.$refs.nextNavigation,
              prevEl: this.prevNavigation ?? this.$refs.prevNavigation,
            },
            thumbs: {
              swiper: this.thumbs,
            },
            grabCursor: true,
            pagination: { type: 'bullets', el: this.$refs.pagination },
            allowTouchMove: true,
            observer: true,
            noSwiping: false,
          },
          this.config
        )
      )
      this.$nextTick(function () {
        this.swiper = swiper
        this.swiper.on(EVENTS.RESIZE, () => {
          this.$emit(EVENTS.RESIZE)
        })

        this.$emit('init', this.swiper)

        this.swiper.on('slideNextTransitionEnd', () => {
          this.$emit('next', this.getSlideIndex())
        })
        this.swiper.on('slidePrevTransitionEnd', () => {
          this.$emit('prev', this.getSlideIndex())
        })
        this.swiper.on('snapIndexChange', () => {
          this.$emit('snapIndexChange', this.getSnapIndex)
        })
        this.swiper.on('slideNextTransitionStart', () => {
          this.swiped = true
          if (this.swiper.previousIndex > this.swiper.realIndex) {
            this.$emit('nextAfterLastSlide')
          }
          this.$emit('startNext', this.getSlideIndex())
        })

        this.swiper.on('slidePrevTransitionStart', () => {
          if (this.swiper.previousIndex < this.swiper.realIndex) {
            this.$emit('prevBeforeFirstSlide')
          }
          this.$emit('startPrev', this.getSlideIndex())
        })
        if (this.slideToCenter) {
          this.centerSlide(this.slideToCenter)
        }
      })
    },
    isCurrentIndex(index) {
      if (this.swiper) {
        return index === this.getSlideIndex()
      }
      return false
    },
    setCurrentIndex(index) {
      this.swiper.slideTo(index + 1)
    },
    getSlideIndex() {
      return this.swiper.realIndex
    },
    onClick() {
      this.$emit('click')
    },
    onNext() {
      this.swiper.slideNext()
      debug('Swiper: slide next')
    },
    onPrev() {
      this.swiper.slidePrev()
      debug('Swiper: slide prev')
    },
    centerSlide(slideIndex) {
      const swiperWidth = this.swiper?.width
      let slideWidthSum = 0
      let targetSlideWidth = 0

      this.swiper.slides.each(function (index, slide) {
        if (index < slideIndex) {
          slideWidthSum += slide.clientWidth
        }
        if (index === slideIndex) {
          targetSlideWidth = slide.clientWidth
        }
      })
      const offset = slideWidthSum - swiperWidth / 2 + targetSlideWidth / 2
      setTimeout(() => {
        this.swiper.setTranslate(-offset)
        this.swiper.updateActiveIndex(slideIndex)
        this.swiper.update()
      }, 300)
    },
  },
}
